var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedTrashCan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user_provided_svg 1 1",
    clipPath: "url(#clip0_1264_4162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1264_4162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 27
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_1306_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 0H0V27H25V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1264_4162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.66667 6.41382H4.00001H22.6667",
    stroke: "#DC3545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.50066 6.4125V4.05C7.50066 3.42343 7.74649 2.82251 8.18407 2.37946C8.62166 1.93641 9.21516 1.6875 9.83399 1.6875H14.5007C15.1195 1.6875 15.713 1.93641 16.1506 2.37946C16.5882 2.82251 16.834 3.42343 16.834 4.05V6.4125M20.334 6.4125V22.95C20.334 23.5766 20.0882 24.1775 19.6505 24.6205C19.213 25.0636 18.6195 25.3125 18.0007 25.3125H6.33399C5.71516 25.3125 5.12166 25.0636 4.68407 24.6205C4.24649 24.1775 4.00066 23.5766 4.00066 22.95V6.4125H20.334Z",
    stroke: "#DC3545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.83398 12.3201V19.4076",
    stroke: "#DC3545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.4987 12.3201V19.4076",
    stroke: "#DC3545",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1264_4162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrashCan);
export default __webpack_public_path__ + "static/media/red_trash_can.b40e7fc3dc08c026def15056e87f350a.svg";
export { ForwardRef as ReactComponent };